import { RouteReuseStrategy, ActivatedRouteSnapshot, BaseRouteReuseStrategy } from "@angular/router";
import { Injectable } from "@angular/core";

@Injectable()
export class DropRouteReuseStrategy extends BaseRouteReuseStrategy implements RouteReuseStrategy {

    // updated behavior - we want to reload route on every last-child navigation (even when the page is same)
    shouldReuseRoute(future: ActivatedRouteSnapshot, current: ActivatedRouteSnapshot): boolean {

        return future.routeConfig === current.routeConfig
            && (future.routeConfig === null
                || !!future.routeConfig.loadChildren
                || !!future.routeConfig.children);
    }
}
